import {
  Component,
  HostListener,
  EnvironmentInjector,
  OnInit,
  ElementRef,
  Renderer2,
  ViewChild,
  inject,
  computed,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { of, forkJoin } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { Note, DataService } from '../../_service/data.service';
//import { OLD__UserSettingsService } from '../../_service/OLD_usersettings.service';
import { FilterParams, FilterService } from '../../_service/filter.service';
// import { PrintService } from '../../_service/print.service';
import { PdfService } from '../../_service/pdf.service';
import { SnackbarService } from '../../_service/snackbar.service';
import { NavigationService } from '../../_service/navigation.service';
import { LayoutService } from '../../_service/layout.service';
import { AppConfig } from '../user-settings/app.config';
import { UserSettingsService } from '../../_service/user-settings.service';
import { ConflictTransferService } from '../../_service/conflict-transfer.service';
import { DataRemoteService } from '../../_service/data-remote.service';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SliderModule } from 'primeng/slider';
import { PopoverModule } from 'primeng/popover';
import hljs from 'highlight.js/lib/core';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { RichEditorComponent } from '../rich-editor/rich-editor.component';
import { AlertService, AlertType } from '../../_service/alert.service'; // Adjust path as needed

// Import only the languages you need (optional but recommended for bundle size)
import typescript from 'highlight.js/lib/languages/typescript';
import javascript from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import xml from 'highlight.js/lib/languages/xml'; // for HTML/XML
import css from 'highlight.js/lib/languages/css'; // for HTML/XML
import bash from 'highlight.js/lib/languages/bash'; //
import json from 'highlight.js/lib/languages/json'; //

hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('python', python);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('json', json);
hljs.registerLanguage('css', css);
hljs.registerLanguage('bash', bash);

interface NewNoteResponse {
  message: string;
  id: string; // Changed from number to string as per your requirement
}

@Component({
  selector: 'view',
  templateUrl: './view-conflict.component.html',
  standalone: true,
  styleUrls: ['./view-conflict.component.scss'],
  providers: [DatePipe], // Add DatePipe to the providers array
  imports: [
    CommonModule,
    FormsModule,
    FileUploadComponent,
    RouterModule,
    MenuModule,
    ButtonModule,
    AppConfig,
    SliderModule,
    PopoverModule,
    RichEditorComponent,
  ],
})
export class ViewConflictComponent implements OnInit {
  localNote!: Note;
  remoteNote!: Note;
  @ViewChild('overlay') overlay!: any;
  @ViewChild('trigger', { read: ElementRef }) triggerRef!: ElementRef<HTMLElement>;

  popoverOpen: boolean = false;
  @HostListener('document:keydown.escape') onEsc() {
    console.log('ESC pressed - hide overlay if open');
    const evt = new MouseEvent('click', { bubbles: true });
    document.dispatchEvent(evt);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(ev: MouseEvent) {
    // Use composedPath for reliable hit-testing (Shadow DOM / portals / appendTo="body")
    const path = (ev.composedPath?.() || []) as EventTarget[];

    const clickedTrigger = this.triggerRef?.nativeElement ? path.includes(this.triggerRef.nativeElement) : false;

    // Popover panel has .p-popover on the root
    const clickedInsidePopover = path.some((t) => (t as HTMLElement)?.classList?.contains('p-popover'));

    if (!clickedTrigger && !clickedInsidePopover) {
      this.overlay?.hide?.();
    }
  }

  filter: any;
  editorContent: string = '';
  isHeaderVisible: boolean = false;
  errorMessage: string = '';
  loadingCounter = 0; // initially count of loading objects in progress
  // zoomFactor: number = 150;
  editorModules = {
    syntax: {
      hljs: hljs, // pass the highlight.js instance
    },
    toolbar: false,
  };
  MobileViewMenuIsVisible: boolean = false;
  menuItems: MenuItem[] = [];
  tempMessage: string = '';
  layoutService: LayoutService = inject(LayoutService);
  isDarkMode = computed(() => this.layoutService.appState().darkMode);
  editorZoomFactor: number = 150;

  constructor(
    private route: ActivatedRoute,
    private data_service: DataService,
    private location: Location,
    private router: Router,
    private filterService: FilterService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    private elRef: ElementRef,
    //private userSettingsService: OLD__UserSettingsService,
    private userSettings: UserSettingsService,
    private injector: EnvironmentInjector,
    // private printService: PrintService,
    private pdfService: PdfService,
    private snackbarService: SnackbarService,
    private titleService: Title,
    private navigationService: NavigationService,
    private conflictTransfer: ConflictTransferService,
    private dataRemoteService: DataRemoteService,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    console.log('ViewConflictComponent: ngOnInit() called');
    this.userSettings.userSettings$.subscribe((settings) => {
      console.log('[UserSettingsService] initialize(): loaded', settings);
      if (settings) {
        console.log('primaryColor from settings =', settings.primaryColor);
        console.log('editorZoomFactor from settings =', settings.editorZoomFactor);
        if (settings.primaryColor) {
          this.layoutService.appState.update((state: any) => ({
            ...state,
            primary: settings.primaryColor,
          }));
        }
        //document.documentElement.style.setProperty('--fontScaleFactor', `${settings.editorZoomFactor}%`);
        //document.documentElement.style.setProperty('--systemZoom', `${settings.systemZoomFactor}%`);
      }
    });
    this.loadingCounter = 0; // Start loading
    const currentNavigation = this.router.getCurrentNavigation();
    this.initializePageMenu();

    if (currentNavigation && currentNavigation.extras && currentNavigation.extras.state) {
      this.filter = currentNavigation.extras.state['filter'];
    } else {
      this.filter = this.filterService.getFilterParams();
    }

    console.log('ViewConflictComponent: About to load data');
    //this.loadData(); // Load note and categories data
    this.localNote = this.conflictTransfer.localNote!;
    this.remoteNote = this.conflictTransfer.remoteNote!;

    if (!this.localNote || !this.remoteNote) {
      // fallback (e.g. navigate back if accessed directly)
      console.warn('No notes found in transfer service!');
    }
  }

  /** Normalize a Quill Delta so that all tables have column widths.
   * Prevents quill-better-table runtime errors when rendering migrated HTML. */
  normalizeDelta(delta: any): any {
    console.log('in normalizeDelta() - delta = ', delta);
    if (!delta || !delta.ops) return { ops: [] };

    const DEFAULT_WIDTH = '200px';
    const tables: Record<string, string[]> = {}; // tableId → widths[]

    const newOps = delta.ops.map((op: any) => {
      if (op.attributes?.['table-cell']) {
        const tableId = op.attributes['table-cell'].tableId || 'default';

        // Initialize widths array for this table
        if (!tables[tableId]) tables[tableId] = [];

        // Ensure width exists
        console.log('op before = ', op);
        if (!op.attributes.width) {
          // Assign width based on column index, or default
          const colIndex = tables[tableId].length;
          const width = tables[tableId][colIndex] || DEFAULT_WIDTH;

          op = {
            ...op,
            attributes: {
              ...op.attributes,
              width,
            },
          };
          console.log('op after = ', op);
          tables[tableId].push(width);
        }
      }
      return op;
    });

    return { ops: newOps };
  }

  initializePageMenu() {
    this.menuItems = [
      {
        label: 'Settings',
        icon: 'fas fa-cog mr-2 !text-blue-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('Settings'),
      },
      { separator: true }, // 🔹 Separator before "Close"
      { label: '––––––––––––––––', disabled: true, styleClass: 'text-gray-500' }, // ✅ Custom separator
      {
        label: 'DEBUG - show raw data',
        icon: 'fa-solid fa-bug-slash mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('ShowRawData'),
      },
      {
        label: 'New note',
        icon: 'pi pi-file-plus mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('New'),
      },
      {
        label: 'Delete note',
        icon: 'pi pi-trash mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('Delete'),
      },
    ];
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
      //this.navigateToEdit(this.note._id);
    }
    if (event.key === 'n') {
      event.preventDefault();
      this.clickNew();
    }
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  setFontSize(size: number): void {
    const quillEditor = this.elRef.nativeElement.querySelector('.ql-container');
    if (quillEditor) {
      // this.renderer.setStyle(quillEditor, 'font-size', `${size}%`);
      this.renderer.setStyle(quillEditor, 'font-size', '10px');
      console.log('in setFontSize(); size = ', size);
    } else {
      console.error('Quill editor not found.');
    }
  }

  isLoading(): boolean {
    return this.loadingCounter > 0;
  }

  toggleMobileMenu(menu: string) {
    if (menu === 'ViewMenu') {
      this.MobileViewMenuIsVisible = !this.MobileViewMenuIsVisible;
    }
  }

  goMobileMenu(selectedItem: string): void {
    console.log('goMobileMenu: ', selectedItem);
    if (selectedItem == 'Edit') {
      //this.navigateToEdit(this.note._id);
    } else if (selectedItem == 'Settings') {
      this.router.navigate(['user-settings']);
    } else if (selectedItem == 'home') {
      this.navigationService.clearHistory();
      this.router.navigate(['home']);
    }
  }

  pageMenu(selectedItem: string): void {
    console.log('pageMenu: ', selectedItem);
    if (selectedItem == 'Edit') {
      //this.navigateToEdit(this.note._id);
    } else if (selectedItem == 'Settings') {
      this.router.navigate(['user-settings']);
    } else if (selectedItem == 'Home') {
      this.navigationService.clearHistory();
      this.router.navigate(['home']);
    } else if (selectedItem == 'New') {
      this.clickNew();
      //this.router.navigate(['home']);
    } else if (selectedItem == 'Delete') {
      this.deleteItem();
    } else if (selectedItem == 'Close') {
      this.navigationService.clearHistory();
      this.router.navigate(['home']);
    } else if (selectedItem == 'ShowRawData') {
      //this.router.navigate(['debug-html', this.note._id]);
    }
  }

  clickNew(): void {
    console.log('clickNew dummy');
  }

  onZoomFactorChange(type: 'system' | 'editor', event: any): void {
    if (type === 'editor') {
      console.log('Editor zoom factor changed to ', this.editorZoomFactor);
      this.userSettings.setEditorZoomFactor(this.editorZoomFactor);
      document.documentElement.style.setProperty('--fontScaleFactor', `${this.editorZoomFactor}%`);
      document.documentElement.style.setProperty('--fontScaleRatio', `${this.editorZoomFactor / 100}`);
    }
  }

  onTogglePopover(event: MouseEvent, overlay: any) {
    // event.stopPropagation(); // prevent click bubbling (important!)
    overlay.toggle(event);
  }

  // persist after user releases the handle (optional but nice)
  persistEditorZoom(): void {
    this.userSettings.setEditorZoomFactor(this.editorZoomFactor);
  }

  toggleHeaderFields(): void {
    console.log('toggle header fields now =', !this.isHeaderVisible);
    this.isHeaderVisible = !this.isHeaderVisible;
  }


  onClose() {
    const previousUrl = this.navigationService.getPreviousUrl();
    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigateByUrl('/home'); // Fallback to home
    }
  }

  navigateToEdit(_id: string) {
    this.router.navigate(['/edit', _id], {
      state: { filter: this.filter },
    });
  }

  deleteItem() {}

  async resolveConflict(source: 'local' | 'remote'): Promise<void> {
    try {
      // 1️⃣ Choose which note to keep
      const chosenNote = source === 'local' ? this.localNote : this.remoteNote;

      if (!chosenNote || !chosenNote._id) {
        console.error('❌ No valid note selected for conflict resolution.');
        this.snackbarService.showErrorMessage('Invalid note selected for resolution.');
        return;
      }

      // Optional user confirmation
      const confirmed = confirm(
        `Are you sure you want to keep the ${source.toUpperCase()} version and overwrite the other?`,
      );
      if (!confirmed) return;

      console.log(`⚖️ Resolving conflict by keeping ${source} version:`, chosenNote);

      // 2️⃣ Save chosen note to IndexedDB (overwrite existing record)
      await this.data_service.saveNoteOffline(chosenNote, true);
      console.log('💾 Local note successfully saved to IndexedDB.');

      // 3️⃣ If local wins, refresh _rev from server before forcing save
      let noteToSave = chosenNote;
      if (source === 'local') {
        const remoteLatest = await firstValueFrom(this.dataRemoteService.getNote(chosenNote._id));
        if (!remoteLatest || !remoteLatest._rev) {
          this.snackbarService.showErrorMessage('Could not fetch latest revision from server.');
          return;
        }
        noteToSave = { ...chosenNote, _rev: remoteLatest._rev };
      }

      // 4️⃣ Save chosen note to CouchDB (via API)
      const putResponse = await firstValueFrom(this.data_service.putNoteToCouchDB(noteToSave));

      if (putResponse.status !== 'success') {
        console.warn('⚠️ CouchDB save failed:', putResponse.error?.message);
        this.snackbarService.showErrorMessage('Failed to update note in CouchDB.');
        return;
      }

      console.log('☁️ CouchDB update successful:', putResponse);

      // 5️⃣ Update local record with latest server revision if returned
      if (putResponse.data) {
        const syncedNote = putResponse.data._id ? putResponse.data : { ...putResponse.data, _id: chosenNote._id };
        await this.data_service.saveNoteOffline(syncedNote, true);
      }

      // 6️⃣ Clean up old conflict revisions in CouchDB
      await this.data_service.cleanupCouchDBConflicts(chosenNote._id);
      console.log('🧹 CouchDB conflict revisions cleaned up.');

      // 7️⃣ User feedback + navigation
      this.snackbarService.showSuccessMessage('Conflict resolved successfully.');
      console.log('✅ Conflict resolved and note synchronized.');

      this.router.navigate(['/home']);
    } catch (err: any) {
      console.error('💥 resolveConflict() failed:', err);
      this.snackbarService.showErrorMessage(
        'An unexpected error occurred while resolving the conflict: ' + (err?.message || 'unknown error'),
      );
    } finally {
      this.loadingCounter = Math.max(0, this.loadingCounter - 1);
    }
  }
}
